import actions from "./actions";

const initState = {
  dashboardData: [],
  dashboardLoading: false,
  dashboardMessage: null,
  dashboardError: null,

  chartData: [],
  chartLoading: false,
  chartMessage: null,
  chartError: null,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardLoading: true,
        dashboardError: null,
        dashboardMessage: null,
      };
    case actions.GET_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        dashboardLoading: false,
        dashboardError: null,
        dashboardMessage: null,
        dashboardData: action.payload,
      };
    case actions.GET_DASHBOARD_DATA_FAILED:
      return {
        ...state,
        dashboardLoading: false,
        dashboardError: action.payload,
        dashboardMessage: null,
      };

    case actions.GET_CHART_DATA:
      return {
        ...state,
        chartLoading: true,
        chartError: null,
        chartMessage: null,
      };
    case actions.GET_CHART_DATA_SUCCESS:
      return {
        ...state,
        chartLoading: false,
        chartError: null,
        chartMessage: null,
        chartData: action.payload,
      };
    case actions.GET_CHART_DATA_FAILED:
      return {
        ...state,
        chartLoading: false,
        chartError: action.payload,
        chartMessage: null,
      };

    default:
      return state;
  }
}
